import { useQuery } from '@tanstack/react-query';
import request from '@teetsh/app/src/utils/request';
import { ElevesView } from '@teetsh/app/src/types/eleves';
import { useSchoolSchoolyear } from '@teetsh/app/src/containers/App/context/SchoolyearSchoolProvider';
import deserializeFilter from '@teetsh/app/src/queries/eleves/views/deserializeFilter';

export const ELEVES_VIEWS_KEY = 'elevesViews';

export default function useElevesViews() {
  const { schoolyear, school } = useSchoolSchoolyear();
  return useQuery({
    queryKey: [ELEVES_VIEWS_KEY, schoolyear.id, school.id],
    queryFn: () =>
      request(
        `/schoolyears/${schoolyear.id}/schools/${school.id}/eleves-views`,
        {
          method: 'GET',
        },
      ).then<ElevesView[]>(res =>
        (res.data || []).map(v => {
          if (v.filters) {
            return {
              ...v,
              filters: deserializeFilter(v.filters),
            };
          }
          return v;
        }),
      ),

    refetchOnWindowFocus: false,
  });
}
